import styled from 'styled-components'

/* Shared responsive layout for the order-history pages
   (CustomerOrder, DeliveryReadyOrder, DeliveredOrder, CanceledOrders). */

export const PageContainer = styled.div`
  max-width: 1080px;
  margin: 0 auto;
  padding: 24px 14px 48px;

  @media screen and (min-width: 480px) {
    padding: 32px 20px 64px;
  }
`;

export const OrderBlock = styled.div`
  margin: 0 0 32px;
`;

export const OrderHead = styled.div`
  background: #fff;
  border: 1px solid rgba(31, 45, 61, 0.08);
  border-left: 4px solid #01bf71;
  border-radius: 14px;
  padding: 16px 18px;
  box-shadow: 0 6px 18px rgba(31, 45, 61, 0.05);
  margin-bottom: 14px;
`;

export const OrderTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 12px;
`;

export const OrderId = styled.div`
  min-width: 0;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.82rem;
  color: #6a7b8a;
  word-break: break-all;

  strong {
    color: #1f2d3d;
  }
`;

export const StatusPill = styled.span`
  flex: 0 0 auto;
  font-size: 0.78rem;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 999px;
  white-space: nowrap;
  background: ${({ $status }) =>
    $status === 'Cancelled' ? 'rgba(239, 83, 80, 0.12)'
    : $status === 'Processing' ? 'rgba(255, 154, 60, 0.16)'
    : 'rgba(1, 191, 113, 0.12)'};
  color: ${({ $status }) =>
    $status === 'Cancelled' ? '#d32f2f'
    : $status === 'Processing' ? '#c96a12'
    : '#0a8f57'};
`;

export const MetaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px 16px;

  @media (min-width: 480px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 768px) {
    grid-template-columns: repeat(5, 1fr);
  }
`;

export const MetaLabel = styled.div`
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #8a99a8;
  margin-bottom: 2px;
`;

export const MetaValue = styled.div`
  color: #1f2d3d;
  font-size: 0.92rem;
  font-weight: 600;
  word-break: break-word;
`;

export const Address = styled.div`
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(31, 45, 61, 0.07);
  color: #46586a;
  font-size: 0.88rem;
  line-height: 1.5;
`;

/* scoped product grid — 2-col on mobile, 3-col on tablet, 4-col on desktop */
export const ProductGrid = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: 360px) {
    grid-template-columns: 1fr;
  }
  @media (min-width: 580px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 880px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const AdminActions = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 14px;
  justify-content: flex-end; /* Align buttons to the right on desktop */

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
    
    & > button, & > .el-button, & > span > button {
      flex: 1 1 100%;
      width: 100%;
      margin: 0 !important; /* Override element-react's adjacent button left margin */
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

export const EmptyMsg = styled.div`
  text-align: center;
  color: #8a99a8;
  padding: 40px 16px;
  background: #fff;
  border: 1px dashed rgba(31, 45, 61, 0.15);
  border-radius: 14px;
`;
